import { H2, Grid, Box } from '@ouster/webviz-react-components';

import { OUSTER_STUDIO_DOWNLOAD_URL } from '../../utils/constants';

export default function OsdAnnouncement() {
  return (
    <Grid
      placeContent="center"
      rowGap="2rem"
      h="100%"
      maxW="800px"
      m="0 auto"
      p="1rem"
    >
      <H2 textAlign="center">Update Required to Log In</H2>
      <Box fontSize={18} lineHeight={1.6}>
        We&apos;ve recently made significant improvements to our security and
        authentication systems. To keep your account secure, you need to update
        the app to the latest version.
      </Box>
      <Box fontSize={18} lineHeight={1.6} fontWeight={600}>
        How to Update:
      </Box>
      <Box
        as="ul"
        paddingLeft="1.5rem"
        fontSize={16}
        lineHeight={1.6}
        listStyleType="disc"
      >
        <Box as="li" mb="1.5rem">
          <b>Method 1: In-App Update</b>
          <br />
          Go to the menu, select &quot;Check for Updates,&quot; and follow the
          prompts to download and install the latest version.
        </Box>
        <Box as="li">
          <b>Method 2: Manual Update</b>
          <br />
          Visit our website and download the latest version of the app. Follow
          the installation instructions provided on the website.
          <br />
          <Box
            as="a"
            href={OUSTER_STUDIO_DOWNLOAD_URL}
            target="_blank"
            rel="noreferrer"
            color="var(--color-unify-active)"
            _hover={{ textDecoration: 'underline' }}
          >
            Download link
          </Box>
        </Box>
      </Box>
    </Grid>
  );
}
